<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <nuxt-link :to="localePath('office-products')" replace>
            {{
            $t("page.products")
            }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="localePath('office-products-glass')" replace>
            {{
            $t("page.glass")
            }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="localePath('office-products-glass-insulating')" replace>
            {{
            $t("page.glass_insulating")
            }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link
            :to="localePath('office-products-glass-insulating-id')"
            replace
          >{{ active.id }} ({{active.name}})</nuxt-link>
        </li>

        <li class="is-active">
          <a aria-current="page">{{$t('page.create_variant')}}</a>
        </li>
      </ul>
    </nav>

    <form @submit.prevent="onSubmit">
      <div class="columns">
        <div class="column">
          <field-select
            :value.sync="thickness"
            :label="`${$t('form.thickness')}:`"
            name="thickness"
            required
            :vvas="$t('form.thickness')"
            :options="thicknessList"
            unit="mm"
          />
        </div>
        <div class="column">
          <field-input
            type="number"
            :value.sync="price"
            name="price"
            required
            :label="`${$t('form.price')}:`"
            :vvas="$t('form.price')"
            unit="€"
          />
        </div>
      </div>

      <div class="field m-t-5">
        <div class="control is-clearfix">
          <button
            class="button is-primary is-pulled-right"
            :class="{ 'is-loading': formLoading }"
          >{{ $t("form.submit") }}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  async asyncData({ store, params, error, query }) {
    try {
      await store.dispatch("glass/insulating/setActive", params.id);
    } catch (e) {
      error(e);
    }
  },

  data() {
    return {
      thickness: "",
      price: "",
      formLoading: false
    };
  },

  computed: {
    active() {
      return this.$store.state.glass.insulating.active;
    },

    thicknessList() {
      if (!this.active) return [];
      const industry = this.$store.state.industries.list
        .filter(e => e.type == "glass")
        .find(e => e.id === this.active.industry_id);
      if (!industry) return [];
      return industry.glass_sizes
        .filter(
          e => !this.active.variants.find(i => i.thickness == e.thickness)
        )
        .map(e => e.thickness);
    }
  },

  methods: {
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.formLoading = true;

      try {
        const { data } = await this.$api.createGlassVariant({
          type: "isolar",
          glass_id: this.$route.params.id,
          price: this.price,
          thickness: this.thickness
        });

        this.$store.commit("glass/insulating/ADD_VARIANT", data);

        this.$router.push(
          this.localePath({
            name: "office-products-glass-insulating-id-variant-edge-processing",
            params: { variant: data.id }
          })
        );
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }

      this.formLoading = false;
    }
  }
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/glass/insulating/create-variant/_id.vue